import React from 'react';
import Switch from 'components/Common/Switch';
import {
  Table, TableBody, TableCell, TableHead, TableRow,
} from '@mui/material';


const DataSourcesAccessTable = ({ list, sources, updateSources }) => {
  const isAllSelected = sources.length === list.length;

  const handleToggle = (source, isChecked) => {
    if (!isChecked) {
      updateSources(sources.filter(id => id !== source.id));
    }
    else {
      updateSources([...sources, source.id]);
    }
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      updateSources(list.map(row => row.id));
    }
    else {
      updateSources([]);
    }
  };

  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell width='5%' sx={{ whiteSpace: 'nowrap' }}>
            <Switch
              checked={isAllSelected}
              label='Select All'
              onChange={e => handleSelectAll(e.target.checked)}
            />
          </TableCell>
          <TableCell align='left' width='95%'>
            Import Source Name
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {list.map(row => (
          <TableRow key={row.id}>
            <TableCell>
              <Switch
                checked={sources.includes(row.id)}
                onChange={e => handleToggle(row, e.target.checked)}
              />
            </TableCell>
            <TableCell>
              {row.displayName}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default DataSourcesAccessTable;
